// extracted by mini-css-extract-plugin
export default {"loadingContainer":"loading_loadingContainer__5KSL+","loader":"loading_loader__cSovX","rotation":"loading_rotation__ng3wu"};